module.exports = __webpack_public_path__ + "img/occupancy-rate-icon.6f4c3647.svg";